import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Map } from "immutable";

import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { createROLineItem } from "MODULES/RepairOrders/actions";
import {
  REPAIR_AWAITING_EVALUATION,
  TEARDOWN
} from "MODULES/RepairOrders/constants";
import Form from "./Form";

function Create({ open, close, onSubmit, repairOrder }) {
  const teardown = repairOrder
    .toJS()
    .line_items.filter(l => l.action_requested === TEARDOWN)[0];
  let remainingCost = 0;
  if (teardown) {
    remainingCost = teardown.remaining_cost;
  }

  return (
    <div>
      <Modal open={open} close={close} dialogClass="modal-lg">
        <Header>
          <Close close={close} />
          <h4 className="modal-title">Add a Part</h4>
        </Header>
        <Form
          close={close}
          onSubmit={onSubmit}
          initialValues={{
            approval_status: REPAIR_AWAITING_EVALUATION,
            final_evaluation_approved: false,
            release_for_shipment: false,
            remaining_cost: remainingCost,
            insurance_type: "None"
          }}
          repairOrder={repairOrder}
        />
      </Modal>
    </div>
  );
}

Create.propTypes = {
  close: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  repairOrder: PropTypes.instanceOf(Map)
};

export default connect(undefined, { onSubmit: createROLineItem })(Create);



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/Create.jsx